const styles = (theme) => ({
    root: {
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
    },
    container: {
        padding: 10,
    },
    img: {
        borderRadius: 6,
        height: 215,
        display: 'block',
        maxWidth: '100%',
        margin: '0 auto',
    },
    imageContain: {
        objectFit: 'contain',
    },
    imageCover: {
        width: '100%',
        objectFit: 'cover',
    },
    title: {
        fontSize: 18,
        color: '#222222',
        fontWeight: 600,
        padding: '10px 0px',
    },
    video: {
        paddingBottom: 10,
    },
    file: {
        padding: '10px 0px',
    },
});

export default styles;
